import React, { useEffect, useState } from "react";
import "./group.css";
import GroupPost from "./GroupPost";
import GroupMembers from "./GroupMembers";
import GroupFeed from "./GroupFeed";
import apiServiceHandler from "../../../service/apiService";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { handleUnreadGroupNotifications, updatePosts } from "../../../redux/groupData";
import HashLoader from "react-spinners/HashLoader";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { firestore } from "../../../firebase";

const GroupBody = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [page, setPage] = useState(0);
  const [noMorePosts, setNoMorePosts] = useState(false);
  const limit = 10;

  const { pathname } = useLocation();
  const pathArr = pathname.split("/");
  const id = pathArr[pathArr.length - 1];

  const loadPosts = useSelector((state) => state.groupData.loadPosts);
  const dispatch = useDispatch();

  const getPosts = async (pageNum = 0, skipLoadStates = false) => {
    try {

      if (!skipLoadStates) {
        setLoading(pageNum === 0);
        setLoadingMore(pageNum > 0);
      }
      const response = await apiServiceHandler(
        "GET",
        `api/post/${id}?page=${pageNum}&offset=${limit}`,
        {}
      );
      console.log(response.data, 'res post is here...')
      const sortedPosts = response.data.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );

      if (pageNum === 0) {
        setPosts(sortedPosts);
        setNoMorePosts(sortedPosts.length < limit);
      } else {

        const uniquePrevPosts = posts?.filter(
          (post) => !sortedPosts.some((newPost) => newPost._id === post._id)
        );
        setPosts([...uniquePrevPosts, ...sortedPosts]);

        if (sortedPosts.length < limit) {
          setNoMorePosts(true);
        }
      }
      // if (pageNum === 0) {
      //   setPosts(sortedPosts);
      //   setNoMorePosts(false);
      // } else {
      //   if (sortedPosts.length < limit) {
      //     setNoMorePosts(true);
      //   }
      //   setPosts((prevPosts) => [...prevPosts, ...sortedPosts]);
      // }
    } catch (error) {
      console.error("Error getting posts:", error);
    } finally {
      if (!skipLoadStates) {
        setLoading(pageNum === 0 ? false : loading);
        setLoadingMore(false);
      }
    }
  };

  useEffect(() => {
    getPosts();
  }, []);

  useEffect(() => {
    if (loadPosts) {
      setPage(0);
      getPosts(0, true);
    }
    dispatch(updatePosts(false));
  }, [loadPosts]);

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    getPosts(nextPage);
  };

  return (
    <div className="page-body">
      <div className="remove-scrollbar">
        <div className="page-section">
          <div className="group-left">
            <GroupPost groupId={id} />
            {!loading ? (
              posts && posts.length > 0 ? (
                <>
                  {posts.map((post, index) => (
                    <GroupFeed key={index} post={post} />
                  ))}
                  {!noMorePosts ? (
                    <button
                      onClick={handleLoadMore}
                      disabled={loadingMore}
                      className="load-more-btn"
                    >
                      {loadingMore ? (
                        <div className="member-loader">
                          <HashLoader color="#d1b794" size={20} />
                          <p>Loading more posts</p>
                        </div>
                      ) : (
                        <span>Load more posts</span>
                      )}
                    </button>
                  ) : (
                    <p style={{ textAlign: "center", color: '#949a9e' }}>No More Posts.</p>
                  )}
                </>
              ) : (
                <p style={{ textAlign: "center" }}>No Posts Found.</p>
              )
            ) : (
              <div className="member-loader">
                <HashLoader color="#d1b794" size={20} />
                <p>Loading Posts</p>
              </div>
            )}
          </div>
          <GroupMembers />
        </div>
      </div>
    </div>
  );
};

export default GroupBody;
